import {changeEvent} from "../../../../../webpack/modules/events";
import {hideOptionErrors} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .options[data-type="vinyl-rug-format"][data-option-type="inline-selectable"] input[name="vinyl-rug-format"]', false, function(element) {
    let option = element.closest('.options');

    hideOptionErrors(option);
});